let utils = require( './utils' );

let footer_nav = ( function( $ ) {

	let $menus,
		anim_speed = 400;

	let _init = function() {
		$menus = $( '#footer .footer-menu' );

		if ( utils.viewport_size().width <= 992 ) {
			_setup_footer_menus_toggle();
		}
	};

	let _setup_footer_menus_toggle = function() {
		$menus.each( function( index, item ) {
			let $menu = $( item );

			$menu.find( '.menu-header a' ).on( 'click', function( e ) {
				e.preventDefault();

				if ( $menu.hasClass( 'animating' ) ) {
					return;
				}

				if ( ! $menu.hasClass( 'open' ) ) {
					_open_menu( $menu );
				} else  {
					_close_menu( $menu );
				}
			} )
		} );
	};

	let _open_menu = function( $menu ) {
		$menu.addClass( 'animating' );
		$menu.removeClass( 'closed' );
		$menu.addClass( 'open' );
		$menu.find( '.toggle-panel' ).slideDown( anim_speed );

		setTimeout( function() {
			$menu.removeClass( 'animating' );
		}, anim_speed );
	};

	let _close_menu = function( $menu ) {
		$menu.addClass( 'animating' );
		$menu.removeClass( 'open' );
		$menu.addClass( 'closed' );
		$menu.find( '.toggle-panel' ).slideUp( anim_speed );

		setTimeout( function() {
			$menu.removeClass( 'animating' );
		}, anim_speed );
	};

	$( document ).ready( _init );

} )( jQuery );

module.exports = footer_nav;